import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllShuffleTickets = createAsyncThunk(
  "ticket/getAllShuffleTickets",
  async ({ lottery_brand_day_code, draw_date }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params: {
          ...(draw_date ? { draw_date } : {}),
          ...(lottery_brand_day_code ? { lottery_brand_day_code } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/shuffle`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || "An error occurred"
        );
      }
    }
  }
);

export const getMyTickets = createAsyncThunk(
  "ticket/getMyTickets",
  async (
    { draw_no, draw_date, status, brand_code, limit, skip },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params: {
          ...(draw_no ? { draw_no } : {}),
          ...(draw_date ? { draw_date } : {}),
          ...(status ? { status } : {}),
          ...(brand_code ? { brand_code } : {}),
          ...(limit ? { limit } : {}),
          ...(skip ? { skip: skip - 1 } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/my-tickets`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || "An error occurred"
        );
      }
    }
  }
);
